import {
  string as yupString,
  object as yupObject,
  boolean as yupBoolean,
  number as yupNumber,
  ref as yupRef,
  date as yupDate,
} from 'yup';
import { isMemorialFundraiser } from '@client/shared/utils/fundraiserUtils/fundraiserUtils';

export function validateString(message) {
  return yupString(message);
}

export function oneOf(applyTo, enumerable, message) {
  return applyTo.oneOf(enumerable, message);
}

export function validateObject(obj) {
  return yupObject().shape(obj);
}

export function required(applyTo, message) {
  return applyTo.required(message);
}

export function validateBoolean(message) {
  return yupBoolean(message);
}

export function validateEmail(message) {
  return yupString().email(message);
}

export function useRef(refName) {
  return yupRef(refName);
}

export function matches(regex, message) {
  return yupString().matches(regex, message);
}

export function min(nr, message) {
  return yupString().min(nr, message);
}

export function max(nr, message) {
  return yupString().max(nr, message);
}

export function createFundraiserSchema() {
  return validateObject({
    title: yupString()
      .required('Ge din insamling ett namn')
      .max(120, 'Titeln får vara max 120 bokstäver.'),
    description: yupString()
      .notRequired()
      .max(4000, 'Beskrivningen är för lång.'),
    targetAmount: matches(
      /^[0-9]{0,8}$/,
      'Ange en summa i enbart siffror'
    ).required('Ange en summa i enbart siffror'),
    fundraiserType: yupNumber().required('Insamlingstyp'),
    memorialFirstName: yupString().when('fundraiserType', (val, schema) => {
      return isMemorialFundraiser(val)
        ? schema
            .required('Du måste ange ett förnamn')
            .max(120, 'Max 120 bokstäver.')
        : schema;
    }),
    memorialLastName: yupString().when('fundraiserType', (val, schema) => {
      return isMemorialFundraiser(val)
        ? schema
            .required('Du måste ange ett efternamn')
            .max(120, 'Max 120 bokstäver.')
        : schema;
    }),
    memorialBirthDate: yupString().when('fundraiserType', (val, schema) => {
      return isMemorialFundraiser(val)
        ? schema
            .required('Du måste ange ett födelsedatum')
            .matches(
              /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/,
              'Ange datum som YYYY-MM-DD.'
            )
        : schema;
    }),
    memorialDeathDate: yupString().when('fundraiserType', (val, schema) => {
      return isMemorialFundraiser(val)
        ? schema
            .required('Du måste ange ett dödsdatum')
            .matches(
              /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/,
              'Ange datum som YYYY-MM-DD.'
            )
        : schema;
    }),
    startDate: yupDate()
      .nullable()
      .required('Ange ett startdatum för insamlingen'),
    endDate: yupDate()
      .nullable()
      .min(yupRef('startDate'), 'Slutdatumet kan inte vara före startdatumet'),
  });
}

export function editFundraiserSchema() {
  return createFundraiserSchema().concat(
    validateObject({
      acceptContentResponsibility: yupBoolean()
        .oneOf([true], 'Du måste acceptera samtycket')
        .required('Du måste acceptera samtycket'),
    })
  );
}

export function guestbookEntrySchema() {
  return validateObject({
    author: yupString().required('Obligatoriskt'),
    title: yupString()
      .required('Obligatoriskt')
      .max(200, 'Beskrivningen är för lång'),
    message: yupString().required('Obligatoriskt'),
  });
}
